import { environment } from 'src/environment';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as uikit from 'uikit';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss', '../modal-screens.scss']
})
export class FeedbackComponent implements OnInit {
  feedbackGroup: any;
  guest: boolean;
  message: any;
  params: object;
  feedbackData: any;

  skinName = environment.skinName;
  constructor(private element: ElementRef, private baseService: BaseService, private feedbackService: FeedbackService,
    private formBuilder: FormBuilder, public settingsService: SettingsService, private storageService: StorageService,
    private fb: FormBuilder, private uikitService: UikitService, private analyticsService: InhouseAnalyticsService,
    private datalayerService: DatalayerService, public configService: ConfigurationService) { 
      this.baseService.guest.subscribe(data => this.guest = data);
      uikit.util.on(document, 'beforehide', '#feedback-screen', ()=>{
        this.feedbackGroup.reset();
        this.feedbackGroup.controls.type.setValue('bug');
      });
    }

  ngOnInit(): void {
    const eventObj = {
      event_type: 'Page View',
      event_name: 'Feedback Page View',
      event_status: 'Success',
    };
    this.analyticsService.trackUserActions(eventObj);

    this.feedbackGroup = this.fb.group({
      feedback: ['', Validators.required],
      type: ['bug', Validators.required]
    });
  }

  browserDetect() {
    const nav = window.navigator;
    const ua = window.navigator.userAgent.toLowerCase();
    // Detect browsers (only the ones that have some kind of quirk we need to work around)
    if ((nav.appName.toLowerCase().indexOf('microsoft') !== -1 || nav.appName.toLowerCase().match(/trident/gi) !== null)) {
      return 'IE';
    }
    if (ua.match(/chrome/gi) !== null) {
      return 'Chrome';
    }
    if (ua.match(/firefox/gi) !== null) {
      return 'Firefox';
    }
    if (ua.match(/safari/gi) !== null) {
      return 'Safari';
    }
    if (ua.match(/webkit/gi) !== null) {
      return 'Webkit';
    }
    if (ua.match(/gecko/gi) !== null) {
      return 'Gecko';
    }
    if (ua.match(/opera/gi) !== null) {
      return 'Opera';
    }
    return null;
  }


// this method using for user feedback details.
  submitFeedback() {
    this.feedbackGroup.markAllAsTouched();
    if(!this.feedbackGroup.valid)
      return;
    if (!this.guest) {
      this.params = {
        u_id: this.storageService.getLocalStore('u_id'),
        type: this.feedbackGroup.controls.type.value,
        content: this.feedbackGroup.controls.feedback.value,
        data: {
          device_model: this.browserDetect()
        }
      };
    } else {
      // if (!this.feedbackGroup.controls.email.valid) {
      //   this.uikitService.staticErrorMessage(emailMsg);
      //   return;
      // }
      this.params = {
        type: this.feedbackGroup.controls.type.value,
        content: this.feedbackGroup.controls.feedback.value,
        data: {
          device_model: this.browserDetect()
        },
        email: this.feedbackGroup.controls.email.value
      };
    }
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Add Comment',
      eventAction: this.feedbackGroup.controls.type.value,
      eventLabel: '',
      loginStatus: (this.storageService.getLocalStore('u_id') ? 'True' : 'False'),
      userId: (this.storageService.getLocalStore('u_id') ? this.storageService.getLocalStore('u_id') : ''),
      notificationStatus: localStorage.getItem('emailNotify') ||  'False',
      region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
      platform: this.baseService.browserType,
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
    if (this.feedbackGroup.valid) {
      this.feedbackService.feedbackfun(this.params).subscribe({
        next: data => {
          const eventObj = {
            event_type: 'Event',
            event_name: 'Feedback Message',
            event_status: 'Success',
            extra_info: this.feedbackGroup.controls.type.value, 
          };
          this.analyticsService.trackUserActions(eventObj);

          this.feedbackData = data;
        }, error: error => {
          const eventObj = {
            event_type: 'Event',
            event_name: 'Feedback Message',
            event_status: 'Failiure',
            event_description: error,
            extra_info: this.feedbackGroup.controls.type.value,
          };
          this.analyticsService.trackUserActions(eventObj);
        }, complete: () => {
          if (this.feedbackData.status_code === 200) {
            this.uikitService.staticSuccessMessage(this.feedbackData.message);
            this.feedbackGroup.reset();
            this.feedbackGroup.controls.type.setValue('bug');
          } else {
            this.uikitService.staticErrorMessage(this.feedbackData.error.message);
          }
        }
      });
    }
  }
}
